import { stringify } from "query-string"

import { apiInstance } from "./api"

const endpoint = "/food"

export const getFoods = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/all?${query}`)

  return response.data
}

export const getDeletedFoods = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/all/deleted?${query}`)

  return response.data
}

export const addInventory = async (foodId, optionId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/${foodId}/option/${optionId}/inventory`, data)

  return response.data
}